module.exports = __webpack_public_path__ + "img/lib_region_flag_kn.89f3c312.png";